// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { otherRevenueMonths } from "./staticMonthsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// other revenue keys
export const OTHER_REVENUE_KEY = "otherRevenue";

export const otherRevenueItems = [OTHER_REVENUE_KEY];

export const initialState = {
  [OTHER_REVENUE_KEY]: {
    title: "Other Revenue",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: otherRevenueMonths,
    years: {
      [years.YEAR_1_KEY]: 5000,
      [years.YEAR_2_KEY]: 10000,
      [years.YEAR_3_KEY]: 15000,
      [years.YEAR_4_KEY]: 20000,
      [years.YEAR_5_KEY]: 25000,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const otherRevenueReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_OTHER_REVENUE_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_OTHER_REVENUE_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_OTHER_REVENUE_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_OTHER_REVENUE_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default otherRevenueReducer;
